import { ApiCourseModel } from '@lerna-core';
import { ApiSimilarCoursesModel } from './courseSimilar.model';

export const courseSimilarAdapter = (
  response: ApiSimilarCoursesModel
): ApiCourseModel[] => {
  return response.data;
};
